import { DEMO_USER } from "./demoMsalAccount.ts";

// The real backend persists the user's language preference server-side, so it
// survives the full-page reloads of the bank-connect redirect flow. The demo
// has no server, and i18next here is configured without any localStorage
// detector — language lives only in memory and is re-derived on every boot from
// the (mocked) user preferences. With a static mock that always returned "en",
// a manual switch to Czech was wiped on the next prefs refetch and, most
// visibly, on the full reload into `/demo-bank-connect`.
//
// This localStorage-backed store stands in for that server persistence: the
// prefs mock reads/writes it, so a manual language switch sticks across reloads.
const DEMO_LANGUAGE_KEY = "fidoo-demo-language";

export function getDemoLanguage(): string {
  try {
    return window.localStorage.getItem(DEMO_LANGUAGE_KEY) ?? DEMO_USER.language;
  } catch {
    return DEMO_USER.language;
  }
}

export function setDemoLanguage(language: string): void {
  try {
    window.localStorage.setItem(DEMO_LANGUAGE_KEY, language);
  } catch {
    // ignore (private mode / storage disabled) — demo falls back to default
  }
}
